import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_datepicker_defaults';

onPageLoad(() => {
  $(document).ready(function () {
    function startTimer(id = 0) {
      if (id > 0) {
        $('.tracker-widget').data('id', id);
      }

      $('.tracker-widget').data('stoptime', false);
      if (!$('.tracker-widget').data('start')) {
        $('.tracker-widget').data('start', new Date());
      }
      timerCycle();

      $('.tracker-panel__stopped-tracking-info').hide();
      $('.tracker-panel__select-project').hide();
      $('.tracker-panel__activated').show();
      $('.tracker-widget').addClass('tracker-widget--active');
      $('.tracker-panel__project-name').text(
        $('.selectize-control--project-dropdown-tracker option:selected').text()
      );

      $(`.tracked-times-tracker[data-id=${id}]`)
        .addClass('tracked-times-tracker--active')
        .find('.tracked-times-tracker__trigger')
        .text('Stop')
        .end()
        .closest('tr')
        .find('.edit-tracked-time')
        .hide();
    }

    function stopTimer(e, duration = null, actionType = 'STOP') {
      if (duration) {
        const id = $('.tracker-widget').data('id');
        $('.tracker-panel__stopped-time').text(duration);
        $('.tracker-panel__stopped-name').text($('.tracker-panel__project-name').text());
        $('.tracker-panel__quick-edit').attr('href', `/tracked_times/${id}/edit`);
      }

      const hr = parseInt($('.tracker-widget').data('hr'));
      const min = parseInt($('.tracker-widget').data('min'));
      const sec = parseInt($('.tracker-widget').data('sec'));

      $('.df-tooltip__tracker-widget-trigger, .tracker-panel__countdown').text('0:00');
      $('.tracker-widget').data({
        stoptime: true,
        hr: 0,
        min: 0,
        sec: 0,
      });
      if ($('.selectize-control--project-dropdown-tracker').length > 0) {
        $('.selectize-control--project-dropdown-tracker')[0].selectize.setValue('');
      }
      if ($('.tracker-panel__dropdown--category').length > 0) {
        $('.tracker-panel__dropdown--category')[0].selectize.setValue('');
      }

      $('.field--tracker-panel').val('');
      $('.tracker-panel__activated').hide();
      $('.tracker-panel__cancel-container').hide();
      $('.tracker-panel__select-project').show();
      $('.tracker-widget').removeClass('tracker-widget--active');
      $('.tracker-panel__stopped-name').text($('.tracker-panel__project-name').text());
      $('.tracker-panel__overtime').hide();
      if ($(e.target).hasClass('h-s-button--stop-timer')) {
        $('.tracker-panel__stopped-tracking-info').show();
      }

      const $trackedTimeRow = $(
        `.tracked-times-tracker[data-id=${$('.tracker-widget').data('id')}]`
      );

      if ($trackedTimeRow.length > 0) {
        if (actionType === 'STOP') {
          $trackedTimeRow.data({
            stoptime: true,
            hr,
            min,
            sec,
          });
        }

        if (actionType === 'DELETE') {
          $trackedTimeRow.remove();
        } else {
          $trackedTimeRow
            .removeClass('tracked-times-tracker--active')
            .find('.tracked-times-tracker__trigger')
            .text('Start')
            .end()
            .closest('tr')
            .find('.edit-tracked-time')
            .show();
        }
      }
    }

    if ($('.tracker-widget').data('stoptime') === false) {
      startTimer(parseInt($('.tracker-widget').data('id')));
    }

    $(document).on('click', '.df-tooltip__tracker-widget-trigger', function () {
      const mustUpgradePlan = $(this).hasClass('df-tooltip__tracker-widget-trigger-must-upgrade');
      if (mustUpgradePlan) {
        const url = '/edesign_upgrade?feature=time_tracker';
        window.open(url, '_blank');
      } else {
        $('.tracker-panel').toggle();
      }
    });

    $(document).on('click', '.tracker-panel__cancel', () => {
      $('.tracker-panel').hide();
      $('.tracker-panel__overtime').hide();
      return false;
    });

    $('html').mousedown((e) => {
      const $target = $(e.target);
      if (!$target.is('.tracker-widget, .tracker-widget *')) {
        $('.tracker-panel').hide();
      }
    });

    $('.tracker-panel__dropdown--category').selectize();

    $(document).on($.modal.OPEN, '.modal--tracked-time-form', (e) => {
      $(e.target).find('.tracker-panel__dropdown--category').selectize();
    });

    $('.selectize-control--project-dropdown-tracker').on('selectizeProject:change', (e, value) => {
      const $startTimerButton = $('.s-button--start-timer');
      $startTimerButton.toggleClass('button-disabled', value === '');
      $startTimerButton
        .closest('.tracker-panel__start-button')
        .toggleClass('df-tooltip', value === '');
    });

    $(document).on('change', '.tracker-panel__dropdown--category', (e) => {
      const $dropdown = $(e.target);
      const $wrapper = $dropdown.closest('.tracker-panel, .modal--tracked-time-form');
      const $hourlyRateField = $wrapper.find('.field--tracker-hourly-rate');

      const categoryId = $dropdown.val();

      if (categoryId === 'ADD') {
        $dropdown[0].selectize.clear();
        $($hourlyRateField).val($hourlyRateField.data('initial-value')).prop('readonly', false);
        window.open($dropdown.data('categories-url'), '_blank');

        return false;
      }

      if (categoryId === '0' || categoryId === '') {
        $($hourlyRateField).val($hourlyRateField.data('initial-value')).prop('readonly', false);
      } else {
        const $hourlyRateDataTag = $wrapper.find(
          `.tracker-widget__hourly-rate-data-for-${categoryId}`
        );

        $hourlyRateField.val($hourlyRateDataTag.val()).prop('readonly', true);
      }
    });

    $(document).on('change', '.field--tracker-hourly-rate', (e) => {
      $(e.target).data('initial-value', $(e.target).val());
    });

    $(document).on('click', '.s-button--start-timer', (e) => {
      const $form = $(e.target).closest('.tracker-panel');
      const selectedProject = $form.find('.selectize-control--project-dropdown-tracker').val();
      const hourlyRate = $form.find('.field--tracker-hourly-rate').val();
      $form.find('.error-message').hide();

      if (selectedProject === '' || !$('.field--tracker-hourly-rate')[0].reportValidity()) {
        return false;
      } else if (!isValidHourlyRate(hourlyRate)) {
        $form
          .find('.error-message--tracked-time')
          .html('Please enter a numerical hourly rate')
          .show();
        return false;
      } else if ($('.tracker-widget').data('stoptime') === true) {
        const trackedTimeData = {
          project_id: $('.selectize-control--project-dropdown-tracker').val(),
          notes: $('.field--tracker-panel').val(),
          hourly_rate: $('.field--tracker-hourly-rate').val(),
        };

        trackedTimeData['tracked_time_category_id'] = $('.tracker-panel__dropdown--category').val();

        $.post('/tracked_times/xhr_create', {
          tracked_time: trackedTimeData,
        }).then((res) => {
          startTimer(res.id);
          return false;
        });
      }
    });

    $(document).on('click', '.h-s-button--stop-timer', (e) => {
      const duration = $('.tracker-panel__countdown').text();
      const id = $('.tracker-widget').data('id');
      $.post(
        `/tracked_times/${id}/xhr_update`,
        {
          force: true, // TODO: this is just to keep the behavior as is until FE ticket is done
          tracked_time: {
            active: false,
            duration,
          },
        },
        (res) => {
          const $selectedRow = $(`tr[data-tracked-time-id="${id}"]`);
          const $selectedRowDuration = $selectedRow.find('.tracked-time-duration');

          if ($selectedRowDuration.length > 0) {
            $selectedRowDuration.text(res.duration);
            $('.financial-card--billable-hours .financial-card__amount').text(res.total_duration);
            $('.financial-card--non-billable-hours .financial-card__amount').text(
              res.total_non_billable_duration
            );
          }
          $('.tracker-widget').data('start', null);
          stopTimer(e, duration);
          $(`label[for='checkbox--create-invoice-w-time-${id}']`).show();
        }
      );
    });

    $(document).on('click', '.t-button--cancel-timer', (e) => {
      const id = $('.tracker-widget').data('id');

      $.post(`/tracked_times/${id}/xhr_cancel`, {}, (res) => {
        if (res.performed_action === 'DELETE') {
          stopTimer(e, null, 'DELETE');
          $(`tr[data-tracked-time-id="${id}"]`).remove();
        } else if (res.performed_action === 'CANCEL') {
          const $selectedRow = $(`tr[data-tracked-time-id="${id}"]`);
          const duration = $selectedRow.find('.tracked-time-duration').text();

          stopTimer(e, $.trim(duration), 'CANCEL');
        }
        $('.tracker-widget').data('start', null);
      });
    });

    $(document).on('click', '.t-button--cancel-timer-request', () => {
      $('.tracker-panel__activated').hide();
      $('.tracker-panel__cancel-container').show();
    });

    $(document).on('click', '.h-s-button--continue-timing', () => {
      $('.tracker-panel__activated').show();
      $('.tracker-panel__cancel-container').hide();
    });

    $(document).on('click', '.tracked-times-tracker__trigger', (e) => {
      const $trackedTime = $(e.target).closest('.tracked-times-tracker');
      const $trackedTimeTable = $(e.target).closest('.data-table__table');
      const $trackerWidget = $('.tracker-widget');
      if ($trackerWidget.hasClass('tracker-widget--active')) {
        const trackerWidgetId = $trackerWidget.data('id');
        const trackedTimeId = $trackedTime.data('id');
        const trackedTimeProject = $trackedTime.data('project');
        const trackerWidgetProject = $trackerWidget.data('project');

        if (trackerWidgetId !== undefined && trackedTimeProject !== undefined) {
          if (trackedTimeId === trackerWidgetId && trackedTimeProject === trackerWidgetProject) {
            $('.tracker-panel__project-name').text($trackedTimeTable.data('projectname'));
            $('.h-s-button--stop-timer').click();
            $('.time-widget-overtracked').remove();
          } else {
            if ($('.time-widget-overtracked').length === 0) {
              if (trackedTimeProject === trackerWidgetProject) {
                $('.main').prepend(
                  '<em class="time-widget-overtracked">A timer is already running in this project. Please stop this timer before starting another.</em>'
                );
              } else {
                $('.main').prepend(
                  `<em class="time-widget-overtracked">A timer is already running in&nbsp;<a href="/projects/${trackerWidgetProject}/tracked_times">another project</a>. Please stop this timer before starting another.</em>`
                );
              }
            }
          }
        }
      } else {
        const id = $trackedTime.data('id');
        const projectId = parseInt($trackedTime.data('project'));

        if ($('.time-widget-overtracked').length > 0) {
          $('.time-widget-overtracked').remove();
        }

        $.post(
          `/tracked_times/${id}/xhr_update`,
          {
            force: true,
            tracked_time: { active: true },
          },
          (res) => {
            $('.tracker-panel__project-name').text($trackedTimeTable.data('projectname'));
            const selectized = $('.selectize-control--project-dropdown-tracker')[0].selectize;
            selectized.setValue(projectId);
            $('.tracker-widget').data({
              hr: res.hours,
              min: res.minutes,
              sec: res.seconds,
              start: res.start,
            });
            $('.tracker-widget').attr({
              'data-id': id,
              'data-project': projectId,
            });
            startTimer(id);
            $(`#checkbox--create-invoice-w-time-${id}`).prop('checked', false);
            $(`label[for='checkbox--create-invoice-w-time-${id}']`).hide();
          }
        );
      }
    });

    $(document).on('click', '.p-button--submit-tracked-time', (e) => {
      const $form = $(e.target).closest('form');
      const duration = $form.find('.field--tracked-time-duration').val();
      const hourlyRate = $form.find('.field--tracker-hourly-rate').val();
      $form.find('.error-message').hide();
      if (!$form[0].checkValidity()) {
        const hourlyRateField = $form.find('.field--tracker-hourly-rate')[0];
        $form.find('.error-message--tracked-time').html(hourlyRateField.validationMessage).show();
        return false;
      } else if (duration.length === 0 || duration === '00:00') {
        $form.find('.error-message--tracked-time').html('Please enter time amount').show();
        return false;
      } else if (!isValidHourlyRate(hourlyRate)) {
        $form
          .find('.error-message--tracked-time')
          .html('Please enter a numerical hourly rate')
          .show();
        return false;
      } else {
        $form.submit();
      }
    });

    $(document).on('click', '.delete-tracked-time', (e) => {
      if ($(e.target).hasClass('delete-tracked-time--disabled')) {
        return false;
      }

      const $form = $(e.target).closest('form');
      $form
        .find('.tracked-time-form__actions')
        .hide()
        .end()
        .find('.tracked-time-form__confirm-delete')
        .show();
    });

    $(document).on('click', '.tracked-time-form__keep-timer-entry', (e) => {
      const $form = $(e.target).closest('form');
      $form
        .find('.tracked-time-form__actions')
        .show()
        .end()
        .find('.tracked-time-form__confirm-delete')
        .hide();
    });

    $(document).on($.modal.OPEN, '.modal--tracked-time-form', () => {
      $('.field--tracked-time-date').datepicker();
    });

    $(document).on($.modal.CLOSE, '.modal--tracked-time-form', (e) => {
      $(e.target).remove();
    });
  });

  const timerCycle = () => {
    if ($('.tracker-widget').data('stoptime') === false) {
      const startDate = new Date($('.tracker-widget').data('start'));
      const currentDate = new Date();

      const activeEntrySeconds = Math.floor(Math.abs(currentDate - startDate) / 1000);

      const hr = parseInt($('.tracker-widget').data('hr'));
      const min = parseInt($('.tracker-widget').data('min'));
      const sec = parseInt($('.tracker-widget').data('sec'));

      startDate.setHours(startDate.getHours() - hr);
      startDate.setMinutes(startDate.getMinutes() - min);
      startDate.setSeconds(startDate.getSeconds() - sec);

      const dateDiff = Math.abs(currentDate - startDate);
      let diffSec = Math.floor(dateDiff / 1000);
      const diffHours = Math.floor(dateDiff / 3600000);

      let diffMins = Math.floor(diffSec / 60) - diffHours * 60;
      diffSec = diffSec - diffMins * 60 - diffHours * 3600;

      if (diffMins < 10) {
        diffMins = `0${diffMins}`;
      }

      if (diffSec < 10) {
        diffSec = `0${diffSec}`;
      }

      if (activeEntrySeconds >= $('.tracker-widget').data('alert-after')) {
        $('.tracker-panel__overtime').show();
        if ($('.time-widget-overtracked').length === 0) {
          $('.main').prepend(
            '<em class="time-widget-overtracked">Whoops! It appears you left a timer running... You\'ll need to stop it before starting another</em>'
          );
        }
      }

      $('.df-tooltip__tracker-widget-trigger').text(`${diffHours}:${diffMins}`);

      $('.tracker-panel__countdown').text(`${diffHours}:${diffMins}:${diffSec}`);

      $(`.tracked-times-tracker[data-id=${$('.tracker-widget').data('id')}]`)
        .siblings('.tracked-time-duration')
        .text(`${diffHours}:${diffMins}`);

      setTimeout(timerCycle, 1000);
    }
  };

  const isValidHourlyRate = (hourlyRate) => {
    if (hourlyRate.length === 0) {
      return true; // hourly rate is optional, so empty value is valid
    }

    return /^[0-9]+(\.[0-9]{0,2})?$/.test(hourlyRate);
  };

  $(document).on('change', '.tracker-panel__dropdown--category', (e) => {
    const serviceId = $(e.target).val();
    const nonBillable = $(`.tracker-widget__hourly-rate-data-for-${serviceId}`).data('nonBillable');
    $('.green-checkbox--tracked-time-non-billable').prop('checked', nonBillable).trigger('change');
    $('.green-checkbox--tracked-time-non-billable').prop('disabled', serviceId !== '0');
  });

  $(document).on('change', '.green-checkbox--tracked-time-non-billable', (e) => {
    const nonBillable = $(e.currentTarget).prop('checked');
    const showHourlyRate = $('.tracked-time-form__hours-container').data('show-rate');

    $('.tracker-panel__hourly-rate-container').toggle(nonBillable !== true && showHourlyRate);
    $('.tracked-time-form__hourly-rate-container').toggle(nonBillable !== true && showHourlyRate);
    if (nonBillable) {
      $('.field--tracker-hourly-rate').val('');
      $('.tracked-time-form__date').appendTo('.tracked-time-form__hours-container');
    } else {
      $('.field--tracker-hourly-rate').val('');
      $('.tracked-time-form__date').appendTo('.tracked-time-form__date-container');
    }
  });
});
